import React from "react";
import Image from "components/image";
import DesktopHeaderData from "./data";
import Search from "components/search";
import { ReactComponent as Heart } from "svgs/fi-rs-heart.svg";
import { ReactComponent as User } from "svgs/fi-rs-user.svg";
import Link from "components/link";
import ShoppingCart from "components/shopping-cart";
import { useCustomer, useSettings } from "hooks/useStore";
import clsx from "clsx/lite";

const DesktopHeader = ({ data, searchData, setIsMenuOpen, variation2, embedHeader }) => {
	const { logo, ...resData } = data;
	const { isMenuOpen, isSearchOpen, toggleSearch } = useSettings(["isMenuOpen", "isSearchOpen", "toggleSearch"]);

	const { isAuthenticated } = useCustomer(["isAuthenticated"]);

	return (
		<nav className={clsx("lg:flex justify-center h-20 hidden relative",
			isMenuOpen && !embedHeader ? "no-border-padding" : "border-b-2",
			variation2 ? "header-variation-2" : "header-variation-1",
			embedHeader ? "bg-transparent *:text-white !border-b-0" : "bg-white")}>
			<div className="flex justify-between items-baseline w-full horizontal-padding standard-section-width">
				<Image image={logo} onClick={() => isSearchOpen && toggleSearch()}
					className={clsx("my-auto", variation2 ? "w-[68px]" : "w-24", embedHeader && "invert")} alt="Company Logo" />
				{variation2 && <Search data={searchData} variation2 embedHeader={embedHeader} />}
				<DesktopHeaderData data={resData} setIsMenuOpen={setIsMenuOpen} embedHeader={embedHeader} />
				<div className="flex gap-3 xxl:gap-5 my-auto">
					{!variation2 && <Search data={searchData} embedHeader={embedHeader} />}
					<Link to="/wishlist" onClick={() => isSearchOpen && toggleSearch()}>
						<Heart className={clsx("fill-black size-5", embedHeader && "invert")} />
					</Link>
					<Link to={isAuthenticated ? "/account/orders" : "/account/login"} aria-label="account"
						className={clsx(embedHeader && "invert")}
						onClick={() => isSearchOpen && toggleSearch()}>
						<User />
					</Link>
					<ShoppingCart redirectToCartPage embedHeader={embedHeader} />
				</div>
			</div>
		</nav>
	);
};

export default DesktopHeader;